import type { ReactElement } from 'react';
import { t } from '@fetmode/i18n';
import { Button } from '@fetmode/ui';

import './application-identity-vendor.css';

export interface ApplicationIdentityVendorProps {
  verified: boolean;
  busy: boolean;
  onVerify: () => void;
}

export function ApplicationIdentityVendor({
  verified,
  busy,
  onVerify,
}: ApplicationIdentityVendorProps): ReactElement {
  return (
    <div className="application-identity">
      <h2>{t('common.studio.onboarding.stepIdVendor')}</h2>
      <p className="application-identity__hint">{t('common.studio.onboarding.stepIdVendorHint')}</p>
      {verified ? (
        <p className="application-identity__status">{t('common.studio.onboarding.identityVerified')}</p>
      ) : (
        <Button
          type="button"
          label={
            busy ? t('common.studio.onboarding.identityVerifying') : t('common.studio.onboarding.verifyWithPartner')
          }
          disabled={busy}
          onClick={onVerify}
        />
      )}
    </div>
  );
}
